<template>
    <div>
        <b-dropdown v-if="hasMultipleItems" aria-role="list">
            <template #trigger="{ active }">
                <b-button
                    outlined
                    :label="buttonText"
                    type="is-secondary"
                    :icon-right="active ? 'angle-up' : 'angle-down'"
                    :loading="loading"
                />
            </template>

            <b-dropdown-item
                @click="onButtonClick(item)"
                v-for="item in list"
                v-bind:key="item.value"
                aria-role="listitem"
                >{{ item.name }}</b-dropdown-item
            >
        </b-dropdown>
        <b-button
            v-else
            :style="downloadStyle"
            type="is-secondary"
            @click="onButtonClick"
            outlined
            :loading="loading"
        >
            <span v-if="emailSended">Correo enviado</span>
            <span v-else>{{ text }}</span>
            <i
                style="vertical-align:sub; top:-1px"
                class="material-icons is-size-6 is-size-6 ml-1 is-relative"
                >{{ icon }}</i
            >
        </b-button>
    </div>
</template>

<script>
export default {
    name: "DownloadBar",
    data() {
        return {
            loading: false,
        };
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        emailSended: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: "Enviar por correo",
        },
        icon: {
            type: String,
            default: "email",
        },
    },
    computed: {
        hasMultipleItems() {
            if (this.list.length > 1) return true;
            else return false;
        },
        downloadStyle() {
            if (this.emailSended) return `pointer-events: none;`;
            else return "";
        },
        buttonText() {
            if (this.emailSended) return `Correo enviado`;
            else return this.text;
        },
    },
    methods: {
        onButtonClick(item) {
            this.loading = true;
            if (this.hasMultipleItems) {
                this.$emit("onButtonClick", item);
            } else {
                this.$emit("onButtonClick", this.list[0]);
            }
        },
    },
    watch: {
        emailSended() {
            if (this.emailSended !== null) {
                this.loading = false;
            }
        },
    },
};
</script>
